import { render, staticRenderFns } from "./SMProductsRightPanel.vue?vue&type=template&id=42990d82"
import script from "./SMProductsRightPanel.vue?vue&type=script&lang=js"
export * from "./SMProductsRightPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports